import React, {useMemo} from 'react';
import withTooltip from "../higherOrderComponents/withTooltip";

const IconBase = props => {

    const {showTooltip = false, ...rest} = props;

    return useMemo(()=>{
        if(showTooltip){
            const ToolTipIcon = withTooltip(SvgBase);
            return <ToolTipIcon {...rest} />
        }
        return (
            <SvgBase {...rest} />
        )
    },[showTooltip]);


}

const SvgBase = props => {
    const { defaultTooltipTitle = '', useTag = false, viewBox = '0 0 24 24', height = 24, width = 24, className, children, ...other} = props;

    if(useTag){
        return(<svg viewBox={viewBox} dangerouslySetInnerHTML={{__html:useTag}}
                    height={height} width={width} className={"ch-menu-icon" + (className ? ' ' + className : '')}
                    {...other} />);
    }

    return(<svg viewBox={viewBox} height={height} width={width} className={"ch-menu-icon" + (className ? ' ' + className : '')} {...other}>
        {children}
    </svg>);
}

export default IconBase;